export const DeviceTypes = {
  Measuring: 'Measuring',
  Collector: 'Collector',
  DTU: 'DTU',
};

export const DisplayTypes = {
  MAP: 'MAP',
  IMG: 'IMG',
  BIM: 'BIM',
};

// 三种展示方式
export const DisplayTypeOptions = [
  { value: 'MAP', label: '地图展示' },
  { value: 'IMG', label: '图文展示' },
  { value: 'BIM', label: 'BIM模型展示' },
];

export const UserTypes = {
  System: 'System',
  Admin: 'Admin',
  Normal: 'Normal',
};

// 标记操作模式
export const PunctuateModes = {
  SELECT: 'SELECT',
  ADD: 'ADD',
  DELETE: 'DELETE',
  EDIT: 'EDIT',
};

// 项目险情状态
export const AlertStatuses = {
  Pending: 'Pending', // 待处理
  Notice: 'Notice', // 已通知
  Confirm: 'Confirm', // 险情确认
  FalseAlarm: 'FalseAlarm', // 误报
  Restore: 'Restore', // 恢复正常
};

// 推送类型
export const PushRuleTypes = [
  { value: 'PushAdmACC', label: '推送加速度' },
  { value: 'PushAdmXYZ', label: '推送坐标观测值' },
  { value: 'PushAdmXYZChange', label: '推送坐标变化值' },
  { value: 'PushAdmEN', label: '推送东北方位角' },
  { value: 'PushGlodonValue', label: 'Glodon格式推送（测试）' },
];

// Marker状态 分别对应正常|一级报警|二级报警|三级报警
export const MarkerStates = ['green', 'yellow', 'orange', 'red'];
// 暂时对应标签颜色
export const AlertStatColors = ['#29B359', '#EDC733', '#ED8533', '#ED4C33'];


export const FormulaType = {
  SYSTEM_FORMULA: 'SYSTEM_FORMULA',
  CUSTOM_FORMULA: 'CUSTOM_FORMULA',
};

export const CollectorTypes = {
  ADM: 'ADM', // 华思阵列位移计采集器
  HDA: 'HDA', // 华思数采
  SDM: 'SDM', // 华思单点采集器
  ROCTEC_API: 'ROCTEC_API', // 岩石科技接入
  WHU_API: 'WHU_API', // 武大数据接入
  HSAPP: 'HSAPP', // 华思APP数据上传
  TGY_API: 'TGY_API', // 同感云接入
  HYDRO: 'HYDRO', // 水文数据接入
  OTHER: 'OTHER', // 其他类型接入
};

export const CollectStragegies = {
  UploadCollect: 'UploadCollect',
  CommandCollect: 'CommandCollect',
  NoCollect: 'NoCollect',
};

export const DeviceCategories = {
  ADM: 'ADM', // 阵列位移计
  HDA2: 'HDA2', // 振弦式渗压计
  HDA3: 'HDA3', // 电流式水位计
  Crack: 'Crack', // 振弦式测缝计
  SDM: 'SDM', // 倾角计
  SDMM: 'SDMM', // 倾角位移计
  SDMX: 'SDMX', // 振动计
  SDMPRO: 'SDMPRO', // 倾角振动计
  TDM: 'TDM', // 轨迹计
  HSL: 'HSL', // 静力水准仪
  Station: 'Station', // 全站仪
  GNSS: 'GNSS', // 全球导航卫星系统
  Camera: 'Camera', // 摄像头
  SGBJ: 'SGBJ', // 声光报警
  RDM: 'RDM', // 手动测斜仪
  IDM: 'IDM', // 图像位移测量仪
  STRAIN: 'STRAIN', // 振弦式应变计
  Steel: 'Steel', // 振弦式钢筋计
  Anchor: 'Anchor', // 振弦式锚索计
  AFM: 'AFM', // 振弦式轴力计
  SPM: 'SPM', // 振弦式土压力计
  Rain: 'Rain', // 雨量计
  Flow: 'Flow', // 流量计
};
